import { CalcRowDocumentationController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Generates documentation and examples for given row (UserDefinedRow)
 * @example
 * ```html
 * <salaxy-calc-row-documentation row="$ctrl.current"></salaxy-calc-row-documentation>
 * ```
 */
export class CalcRowDocumentation extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The calculation row. */
      row: "<"
    };

    /** Uses the CalcRowDocumentationController */
    public controller = CalcRowDocumentationController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/rows/CalcRowDocumentation.html";
}
